import { createAction, props } from '@ngrx/store';
import { IGroup, IRole } from '@app/settings/account/components/groups/models/models';

export const getRolesAction = createAction('[Roles] Get - Roles');
export const getRolesCompleteAction = createAction('[Roles] Get - Roles completed', props<{ payload: IRole[] }>());
export const getRolesFailedAction = createAction('[Roles] Get - Roles failed');

